import React from 'react'
import PropTypes from 'prop-types'
import { TooltipFab } from '..'
import { useTranslation } from 'react-i18next'
import { Edit, Save } from '@material-ui/icons'

function EditButton({ isEditting, onEdit, onSave }) {
  const { t } = useTranslation()

  if (isEditting)
    return (
      <TooltipFab
        Icon={Save}
        onClick={onSave}
        tooltip={t('default.btnEdit.save')}
      />
    )

  return (
    <TooltipFab
      Icon={Edit}
      onClick={onEdit}
      tooltip={t('default.btnEdit.edit')}
    />
  )
}

EditButton.propTypes = {
  isEditting: PropTypes.bool,
  onEdit: PropTypes.func,
  onSave: PropTypes.func,
}

EditButton.defaultProps = {
  isEditting: false,
  onEdit: () => true,
  onSave: () => true,
}

export default EditButton